import { Navbar, NavbarBrand } from "reactstrap";
import { Images } from "@workspace/common";
export default function NavigationBar() {
  return (
    <Navbar className="p-2 bg-white">
      <NavbarBrand href="https://www.aven-sys.com" target="_blank">
        <img
          src={Images.avensys_full_logo}
          alt="avensys-logo"
          className="me-2"
          width="150"
        />
      </NavbarBrand>
    </Navbar>
  );
}
